import { createFileRoute } from '@tanstack/react-router';

import { RouteGuard } from '../lib/route-guard.js';

export const Route = createFileRoute('/purchase-orders')({
  component: () => <RouteGuard route="/purchase-orders" />,
});
